import { colors } from './';

export const colorOptions = t => [
  {
    value: 'multicolor',
    label: t('select.color.multicolor'),
    color: '#F5F6F7',
    labelColor: colors.navy,
  },
  {
    value: 'pattern',
    label: t('select.color.pattern'),
    color: '#F5F6F7',
    labelColor: colors.navy,
  },
  {
    value: 'transparent',
    label: t('select.color.transparent'),
    color: '#F5F6F7',
    labelColor: colors.navy,
  },
  {
    value: 'black',
    label: t('select.color.black'),
    color: '#000000',
    labelColor: colors.white,
  },
  {
    value: 'grey',
    label: t('select.color.grey'),
    color: '#838E9C',
    labelColor: colors.white,
  },
  {
    value: 'white',
    label: t('select.color.white'),
    color: '#ffffff',
    labelColor: colors.navy,
  },
  {
    value: 'beige',
    label: t('select.color.beige'),
    color: '#FFFAEC',
    labelColor: colors.navy,
  },
  {
    value: 'gold',
    label: t('select.color.gold'),
    color:
      'linear-gradient(84.15deg, #FEFFBD -3.92%, #E0DB57 57.82%, #FEFFBD 111.2%)',
    labelColor: colors.navy,
  },
  {
    value: 'silver',
    label: t('select.color.silver'),
    color:
      'linear-gradient(84.15deg, #F1F1F1 -3.92%, #D9D9D9 53.64%, #FFFFFF 111.2%)',
    labelColor: colors.navy,
  },
  {
    value: 'pink',
    label: t('select.color.pink'),
    color: '#FF8EB7',
    labelColor: colors.white,
  },
  {
    value: 'coral',
    label: t('select.color.coral'),
    color: '#FFA68A',
    labelColor: colors.white,
  },
  {
    value: 'turquoise',
    label: t('select.color.turquoise'),
    color: '#22D9CE',
    labelColor: colors.white,
  },
  {
    value: 'light-green',
    label: t('select.color.light.green'),
    color: '#4EE25D',
    labelColor: colors.white,
  },
  {
    value: 'brown',
    label: t('select.color.brown'),
    color: '#8F6649',
    labelColor: colors.white,
  },
  {
    value: 'red',
    label: t('select.color.red'),
    color: '#FF5630',
    labelColor: colors.white,
  },
  {
    value: 'orange',
    label: t('select.color.orange'),
    color: '#FF8B00',
    labelColor: colors.white,
  },
  {
    value: 'yellow',
    label: t('select.color.yellow'),
    color: '#FFC400',
    labelColor: colors.white,
  },
  {
    value: 'green',
    label: t('select.color.green'),
    color: '#36B37E',
    labelColor: colors.white,
  },
  {
    value: 'ocean',
    label: t('select.color.ocean'),
    color: '#00B8D9',
    labelColor: colors.white,
  },
  {
    value: 'blue',
    label: t('select.color.blue'),
    color: '#0052CC',
    labelColor: colors.white,
  },
  {
    value: 'purple',
    label: t('select.color.purple'),
    color: '#5243AA',
    labelColor: colors.white,
  },
];
